<template>
    <LayoutsDefaultHeaderAccountSubstitutions />
</template>
